export const enhancer = el => {
  const target = document.querySelector(`#${el.getAttribute('aria-controls')}`);
  el.addEventListener('click', e => {
    el.setAttribute('aria-expanded', `${!(el.getAttribute('aria-expanded') === 'true')}`);
    target.setAttribute('aria-hidden', `${!(target.getAttribute('aria-hidden') === 'true')}`);
  });
};
